<template>
    <v-card color="grey lighten-2">
        <v-toolbar dense dark color="teal darken-3">
            <v-icon>gavel</v-icon>
            <v-toolbar-title>&nbsp; Reporte de valuaciones por dirección - {{ departmentNameForReport }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onClose" v-on="on">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-toolbar-items>

            <!-- Menú lateral para dispositivos con ventanas chicas: -->
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="hidden-md-and-up">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list color="grey lighten-5">
                    <v-divider></v-divider>
                    <v-list-item @click="onClose">
                        <v-list-item-title>
                            <v-icon color="teal darken-1">close</v-icon>&nbsp; Cerrar
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>

        <!-- Container para Información: -->
        <v-container pa-2 grid-list-md>
            <!-- Renglón único para Información: -->

            <v-layout>
                <v-flex xs12>
                    <v-card color="grey lighten-5">
                        <v-toolbar height="30" dense color="teal lighten-3" flat>
                            <v-toolbar-title class="my-list-title">Valuaciones</v-toolbar-title>
                        </v-toolbar>

                        <v-container fluid>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-data-table
                                        :headers="headerResults"
                                        :items="departmentReportResults"
                                        single-select
                                        class="elevation-1"
                                        dense
                                        fixed-header
                                        height="400px"
                                        :loading="waitCursor"
                                        loading-text="Cargando resultados..."
                                        locale="es-MX"
                                        :items-per-page="1"
                                        no-data-text="No hay valuaciones registradas para esta dirección."
                                        disable-pagination
                                        hide-default-footer
                                    ></v-data-table>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center justify-end row fill-height>
                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                    <v-btn
                                        color="teal darken-3"
                                        class="text-none"
                                        text
                                        @click="onBack"
                                    >Reprocesar Reporte</v-btn>
                                    <v-btn
                                        color="teal darken-3"
                                        class="text-none"
                                        text
                                        @click="onClose"
                                    >OK</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DepartmentReportResults',
    data() {
        return {
            drawer: false,
            userResults: [],
            headerResults: [],
            headerColumnWidth: '12.5%'
        };
    },
    created() {
        //this.userResults.push(this.departmentReportResults);
        //console.log('userResults = ', this.userResults);

        //Si hay por lo menos un resultado de escala propia, se reduce el tamaño de las columnas de la tabla:
        var i;
        var bEscalaPropia = false;
        for (i = 0; i < this.departmentReportResults.length; i++) {
            if (this.departmentReportResults[i].propia !== null) {
                this.headerColumnWidth = '11.11%';
                bEscalaPropia = true;
                break;
            }
        }

        this.headerResults = [
            {
                text: 'Fecha',
                value: 'date',
                align: 'start',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'Puesto',
                value: 'puesto',
                align: 'start',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'Puntos',
                value: 'puntos',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'ValueWise',
                value: 'valuewise',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'Towers Watson',
                value: 'towerswatson',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'Mercer',
                value: 'mercer',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'HAY',
                value: 'hay',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            },
            {
                text: 'Aon',
                value: 'aon',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            }
        ];

        if (bEscalaPropia) {
            this.headerResults.push({
                //text: this.departmentNameForReport,
                text: this.company.nombre,
                value: 'propia',
                align: 'end',
                divider: true,
                width: this.headerColumnWidth
            });
        }
    },
    methods: {
        onBack() {
            this.showDepartmentReportResultsDlg = false;
        },
        onClose() {
            this.showDepartmentReportResultsDlg = false;
            this.$store.dispatch('updateSelectedDeptForReport', '');
            this.$router.push('/');
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'company',
            'departmentReportResults',
            'departmentNameForReport'
        ]),
        showDepartmentReportResultsDlg: {
            get() {
                return this.$store.getters.showDepartmentReportResultsDlg;
            },
            set(showDepartmentReportResultsDlg) {
                this.$store.dispatch(
                    'updateShowDepartmentReportResultsDlg',
                    showDepartmentReportResultsDlg
                );
            }
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.results {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
.my-car-table {
    width: 100%;
}
</style>